module.exports = __webpack_public_path__ + "img/logo-light.bd56a0a8.png";